export const DAPP_QUERIES = [
  'Validators',
  'Index',
  'KnotsByIds',
  'getDETHMinted',
  'getStakehouseAccount',
  'getStakehouseAccounts'
]
